import { motion } from "framer-motion";
import { fadeUp } from "@/lib/anim";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      transition={{ delay }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
